<template>
    <div>
      <LiquidationAttachments/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import LiquidationAttachments from '@/components/EditLiquidationAttachments.vue'
  
  export default {
    name: 'liquidation-attachment-view',
    components: {
      LiquidationAttachments
    }
  }
  </script>
  